module.exports = __webpack_public_path__ + "static/img/netpc.0960dd7b.svg";